import { render, staticRenderFns } from "./authorHeader.vue?vue&type=template&id=6fca14e9&scoped=true&"
import script from "./authorHeader.vue?vue&type=script&lang=js&"
export * from "./authorHeader.vue?vue&type=script&lang=js&"
import style0 from "./authorHeader.vue?vue&type=style&index=0&id=6fca14e9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fca14e9",
  null
  
)

export default component.exports